import React , {Component} from 'react';
// import '../assets/css/oneStepSolution.css';
import CardSmall from './card_small';
import CardLarge from './card_large';

import '../assets/css/oneStepSolution.css';

//import plugins
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js';

//import images
import card_s_1 from '../assets/img/card_small_1.svg';
import card_s_2 from '../assets/img/card_small_2.svg';
import card_s_3 from '../assets/img/card_small_3.svg';
import icon_puzzle from '../assets/img/icon_puzzle.svg';
import icon_service from '../assets/img/icon_service.svg';
import icon_curriculum from '../assets/img/icon_curriculum.svg';
import homepage_curriculum from '../assets/img/homepage_curriculum.svg';
import homepage_product from '../assets/img/homepage_product.svg';
import homepage_service from '../assets/img/homepage_service.svg';







const oneStepSolution ={
	card_s:{
		1:{
			name:'curriculum',
			content:'課程',
			img:card_s_3,
		},
		2:{
			name:'product',
			content:'產品',
			img:card_s_1,
		},
		3:{
			name:'service',
			content:'服務',
			img:card_s_2,
		},
	},
	card_l:{
		1:{
			name:'curriculum',
			title:'課程',
			content:'基於項目的課程培養體系，充分挖掘個人潛能',
			icon:icon_curriculum,
			img:homepage_curriculum,
		},
		2:{
			name:'product',
			title:'產品',
			content:'模組化產品，滿足學生的個性化需求',
			icon:icon_puzzle,
			img:homepage_product,
		},
		3:{
			name:'service',
			title:'服務',
			content:'一條龍的教學服務，提供全方位課程支持',
			icon:icon_service,
			img:homepage_service,
		},
	},
}


class OneStepSolution extends Component{
	render(){
		return(
			<div>
				<div className="oneStepSolutionHeader">
					<h2 className="uk-heading-hero">STEAM教育</h2>
					<h3>一體化解決方案</h3>
				</div>
				<div className="uk-flex" style={{padding:'10%'}} uk-scrollspy="cls: uk-animation-slide-bottom-small; target:  > .uk-card; delay: 500; repeat: true">
					{Object.keys(oneStepSolution.card_s).map((x,y)=>
						<CardSmall
							name={oneStepSolution.card_s[x].name}
							key={y}
							content={oneStepSolution.card_s[x].content}
							img={oneStepSolution.card_s[x].img}
						/>)}
				</div>
				<div style={{padding:'0 10%'}} uk-scrollspy="cls: uk-animation-slide-left; target:  > .uk-card; delay: 3000;">
					{Object.keys(oneStepSolution.card_l).map((x,y) =>
						<CardLarge
							key={y}
							name={oneStepSolution.card_l[x].name}
							title={oneStepSolution.card_l[x].title}
							content={oneStepSolution.card_l[x].content}
							img={oneStepSolution.card_l[x].img}
							icon={oneStepSolution.card_l[x].icon}
						/>)}
				</div>
			</div>
		)
	}
}

export default OneStepSolution;
